


































import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/app';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

export default Vue.extend({
  name: 'Login',
  components: { VariableInput },
  data() {
    return {
      accountData: new models.CAuth(),
      saveUserData: true,
      items: [
        {key: 'mail', name: 'メールアドレス', type: vi.INPUT_TYPE.TEXT, placeholder: 'メールアドレス', required: true, checks: [vi.CHECK_TYPE.EMAIL], error: '', max: 40, class: 'text_40' },
        {key: 'password', name: 'パスワード', type: vi.INPUT_TYPE.PASSWORD, placeholder: 'パスワード', required: true, checks: [vi.CHECK_TYPE.PASSWORD], error: '', max: 40 },
      ] as vi.IVariableInput[],
      dispToggleInputs: [
        'password',
      ],
      dispToggles: {
        password: 'password',
      },
    };
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  created() {
    if (process.env.VUE_APP_MODE === 'PROD') {
      (this as any).$gtm.trackView( location.pathname.toString() , location.toString());
    }
    if (localStorage.userEmail) {
      this.$data.accountData.mail = localStorage.userEmail;
    }
  },
  async mounted() {
    const carouselControlNext = document.getElementsByClassName('carousel-control-next');
    const carouselControlPrev = document.getElementsByClassName('carousel-control-prev');
    if (carouselControlNext && carouselControlNext[0]) {
      carouselControlNext[0].removeAttribute('href');
    }
    if (carouselControlPrev && carouselControlPrev[0]) {
      carouselControlPrev[0].removeAttribute('href');
    }
    // document.getElementsByClassName('carousel-control-next')[0].removeAttribute('href');
    // document.getElementsByClassName('carousel-control-prev')[0].removeAttribute('href');
    await this.$router.push('/Login', () => {});
  },
  methods: {
    onClickLogin() {
      // vallidation check
      if (vi.checkValues(this.accountData, this.items) > 0) {
        return;
      }
      if (this.$data.saveUserData) {
        localStorage.userEmail = this.$data.accountData.mail;
      }
      // ↓ 既に登録していたユーザーがログインできなくなる可能性があるため一旦コメントアウト
      // const validPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,40}$/;
      // if (!validPassword.test(this.accountData.password)) {
      //   this.items[1].error = '半角大小英数字を1文字ずつ含む8文字以上40字以内';
      //   return;
      // }
      this.$emit('login', this.accountData);
    },
    dispToggle(input: string) {
      const el = document.querySelector('#' + input + '-input input') as any;

      if (el.type === 'text') {
        el.type = 'password';
      } else {
        el.type = 'text';
      }
    },
    toSignup() {
      this.$emit('change', 'Signup');
    },
    toForgetPassword() {
      this.$emit('change', 'Forget');
    },
  },
});
